import { getLocale } from "../runtime";

const da_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Når din pakke er leveret, modtager du en besked fra fragtfirmaet.`
};

const en_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `When your package has been delivered, you will receive a message from the shipping company.`
};

const es_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Cuando tu paquete sea entregado, recibirás una notificación de la empresa de transporte.`
};

const fi_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kun pakettisi on toimitettu, saat ilmoituksen kuljetusyritykseltä.`
};

const nb_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Når pakken din er levert, får du en melding fra transportøren.`
};

const sv_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `När ditt paket har levererats får du ett meddelande från fraktbolaget.`
};

const packagedelivered = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_packagedelivered(inputs)
	if (locale === "en") return en_packagedelivered(inputs)
	if (locale === "es") return es_packagedelivered(inputs)
	if (locale === "fi") return fi_packagedelivered(inputs)
	if (locale === "nb") return nb_packagedelivered(inputs)
	if (locale === "sv") return sv_packagedelivered(inputs)
	return "packageDelivered";
};

export { packagedelivered as "packageDelivered" };